import { AssaysViewPortionResponse } from '@/components/assays-view/services/assays-view-portion/assays-view-portion.dto'
import { AssayModalAssayWithValuableConceptResponse } from '@/components/assays-view/services/assays-view-assay/assays-view-assay.dto'

export interface AssayBatchModalState {
    selectedPortions: AssaysViewPortionResponse[]
    loading: boolean
    labIds: number[]
    numberOfCopies: number
    assays: AssayModalAssayWithValuableConceptResponse[]
}
export const initialAssayBatchModalState =
    (): AssayBatchModalState => ({
        selectedPortions: [],
        loading: false,
        labIds: [],
        numberOfCopies: 1,
        assays: []
    })
